module.exports = __webpack_public_path__ + "img/stena02.d2496b1f.jpg";